// extracted by mini-css-extract-plugin
module.exports = {"list":"e_p1","button":"e_q1"};